module.exports = __webpack_public_path__ + "static/media/28.d9b5e4f7.jpg";